import { render, staticRenderFns } from "./staffModal.vue?vue&type=template&id=9f193b36&scoped=true"
import script from "./staffModal.vue?vue&type=script&lang=js"
export * from "./staffModal.vue?vue&type=script&lang=js"
import style0 from "./staffModal.vue?vue&type=style&index=0&id=9f193b36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f193b36",
  null
  
)

export default component.exports